import React from 'react';
import {
  CheckCircle2,
  Clock3,
  PackageCheck,
  Play,
  Users,
} from 'lucide-react';

const ESTADOS = {
  CONFIRMADO: {
    label: 'Pendiente',
    card: 'border-amber-200 bg-amber-50',
    badge: 'bg-amber-100 text-amber-800',
  },
  EN_PREPARACION: {
    label: 'En preparación',
    card: 'border-blue-200 bg-blue-50',
    badge: 'bg-blue-100 text-blue-800',
  },
  LISTO: {
    label: 'Listo para entregar',
    card: 'border-emerald-200 bg-emerald-50',
    badge: 'bg-emerald-100 text-emerald-800',
  },
};

function formatearHora(valor) {
  if (!valor) return '';

  return new Date(valor).toLocaleTimeString('es-AR', {
    hour: '2-digit',
    minute: '2-digit',
  });
}

export default function PedidoCocinaCard({
  pedido,
  accionando,
  onIniciar,
  onListo,
  onEntregar,
}) {
  const config =
    ESTADOS[pedido.estado] || ESTADOS.CONFIRMADO;

  const items = Array.isArray(pedido.items)
    ? pedido.items
    : [];

  return (
    <article
      className={[
        'overflow-hidden rounded-2xl border-2 bg-white shadow-sm',
        'transition-all hover:-translate-y-0.5 hover:shadow-md',
        config.card,
      ].join(' ')}
    >
      <div className="flex items-start justify-between gap-3 border-b border-black/5 p-5">
        <div>
          <div className="flex items-center gap-2">
            <span className="text-2xl font-black text-azul-oscuro">
              Pedido #{pedido.id}
            </span>

            <span
              className={[
                'rounded-full px-2.5 py-1 text-xs font-bold',
                config.badge,
              ].join(' ')}
            >
              {config.label}
            </span>
          </div>

          <div className="mt-2 flex flex-wrap items-center gap-4 text-sm font-semibold text-gray-600">
            <span>{pedido.mesa_nombre || `Mesa ${pedido.mesa_id}`}</span>

            <span className="flex items-center gap-1">
              <Users size={15} />
              {pedido.comensales || 0}
            </span>

            {pedido.confirmado_at && (
              <span className="flex items-center gap-1">
                <Clock3 size={15} />
                {formatearHora(pedido.confirmado_at)}
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="space-y-3 p-5">
        {items.map((item) => (
          <div
            key={item.id}
            className="rounded-xl border border-black/5 bg-white p-3"
          >
            <div className="flex items-start justify-between gap-3">
              <div className="flex gap-3">
                <span className="flex h-8 min-w-8 items-center justify-center rounded-lg bg-azul-oscuro text-sm font-black text-white">
                  {Number(item.cantidad)}
                </span>

                <div>
                  <p className="font-bold text-azul-oscuro">
                    {item.producto_nombre || item.nombre || `Producto #${item.producto_id}`}
                  </p>

                  {item.observaciones && (
                    <p className="mt-1 text-sm font-medium text-gray-500">
                      {item.observaciones}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}

        {pedido.observaciones && (
          <div className="rounded-xl border border-amber-200 bg-amber-50 p-3">
            <p className="text-xs font-bold uppercase tracking-wide text-amber-700">
              Observación del pedido
            </p>

            <p className="mt-1 text-sm font-semibold text-amber-900">
              {pedido.observaciones}
            </p>
          </div>
        )}
      </div>

      <div className="border-t border-black/5 bg-white p-4">
        {pedido.estado === 'CONFIRMADO' && (
          <button
            type="button"
            onClick={() => onIniciar(pedido.id)}
            disabled={accionando}
            className="flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-azul-oscuro via-azul-lago to-verde-esmeralda text-sm font-bold text-white shadow-sm transition hover:brightness-105 disabled:opacity-60"
          >
            <Play size={18} />
            Iniciar preparación
          </button>
        )}

        {pedido.estado === 'EN_PREPARACION' && (
          <button
            type="button"
            onClick={() => onListo(pedido.id)}
            disabled={accionando}
            className="flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-emerald-600 text-sm font-bold text-white shadow-sm transition hover:brightness-105 disabled:opacity-60"
          >
            <CheckCircle2 size={18} />
            Marcar listo
          </button>
        )}

        {pedido.estado === 'LISTO' && (
          <button
            type="button"
            onClick={() => onEntregar(pedido.id)}
            disabled={accionando}
            className="flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-azul-oscuro text-sm font-bold text-white shadow-sm transition hover:brightness-105 disabled:opacity-60"
          >
            <PackageCheck size={18} />
            Marcar entregado
          </button>
        )}
      </div>
    </article>
  );
}
